<script setup lang="ts">
import type { Component } from 'vue';

import { formatInt } from './analyticsUtils';

defineProps<{
    title: string;
    icon: Component;
    badge: string;
    rows: { label: string; count: number }[];
}>();
</script>

<template>
    <div
        class="flex min-w-0 flex-col gap-3.5 rounded-2xl border bg-card p-[18px] shadow-sm"
    >
        <div class="flex items-center gap-2.5">
            <span
                class="inline-flex size-[26px] items-center justify-center rounded-lg"
                :class="badge"
            >
                <component :is="icon" class="size-3.5" />
            </span>
            <span class="text-sm font-bold">{{ title }}</span>
        </div>
        <div class="flex flex-col">
            <div
                v-for="(row, index) in rows"
                :key="row.label"
                class="flex items-center justify-between gap-2.5 py-2"
                :class="index > 0 ? 'border-t border-grey20' : ''"
            >
                <span class="min-w-0 text-[13.5px] text-muted-foreground">
                    {{ row.label }}
                </span>
                <span class="shrink-0 text-sm font-bold tabular-nums">
                    {{ formatInt(row.count) }}
                </span>
            </div>
        </div>
    </div>
</template>
